<div class="wrapper">
  <div class="inner">
    <app-screens></app-screens>
    <div class="text">{{ 'Common.Devices.maxDevices' | translate }}</div>
    <div class="number">3 台</div>
  </div>
  <div>
    <app-button [text]="'Common.Devices.getMore' | translate" (buttonClick)="handleClick()"></app-button>
  </div>
</div>